<app-modal id="blocking-modal" blocking="true" #modalComponent>
    <div class="blocking-modal-container">
        <h3>{{text | translate}}</h3>
    </div>
</app-modal>
